import { SET_LOGGEDIN, SET_TOKEN, SET_USER_DETAILS, SET_MENU_ITEMS, 
    SET_SELLERCREATION, SET_ACCOUNTTYPE, SET_BUYNOWPRODUCTS, SET_ACCOUNT_DETAILS, 
    SET_REGION, SET_FlAWFILTER, SET_OCCUPATIONFILTER, SET_ZODIACFILTER, SET_STATUSFILTER, 
    SET_COUNT_API, SET_EDUCATIONLIST, SET_FULL_EDUCATIONLIST, SET_ZODIACSIGNS, SET_FLAWS, 
    SET_STATUS, SET_OCCUPATION, SET_ALLSTARS, SET_FULL_OCCUPATIONS, SET_TEDUCATIONS, SET_TFLAWS, 
    SET_TSTATUS, SET_TOCCUPATION, SET_DHISA, SET_INITIAL_LOADING_FILTER, SET_SEARCH_VALUE, SET_MAX_AGE, SET_MIN_AGE,SET_SEARCH_COUNT, SET_TDHISA,
    SET_FETCH_USER_DETAILS} from "./constants";

export const setLoggedIn = (value) => {
    if (!value) {
        localStorage.removeItem('token')
    }
    return {
        type: SET_LOGGEDIN,
        payload: value
    }
}

export const setToken = value => ({
    type: SET_TOKEN,
    payload: value
})

export const setUserDetails = value => ({
    type: SET_USER_DETAILS,
    payload: value
})

export const setMenuItems = value => ({
    type: SET_MENU_ITEMS,
    payload: value
})

export const setSellerCreation = value => ({
    type: SET_SELLERCREATION,
    payload: value
})

export const setAccountType = value => ({
    type: SET_ACCOUNTTYPE,
    payload: value
})

export const setBuyNowProducts = value => ({
    type: SET_BUYNOWPRODUCTS,
    payload: value
})

export const setAccountDetails = value => ({
    type: SET_ACCOUNT_DETAILS,
    payload: value
})

export const setRegions = value => ({
    type: SET_REGION,
    payload: value
})

export const setFlawFilter = value => ({
    type: SET_FlAWFILTER,
    payload: value
})

export const setOccupationFilter = value => ({
    type: SET_OCCUPATIONFILTER,
    payload: value
})

export const setZodiacSignFilter = value => ({
    type: SET_ZODIACFILTER,
    payload: value
})

export const setStatusFilter = value => ({
    type: SET_STATUSFILTER,
    payload: value
})

export const setCountApi = value => ({
    type: SET_COUNT_API,
    payload: value
})

export const setEducationList = value => ({
    type: SET_EDUCATIONLIST,
    payload: value
})

export const setFullEducations = value => ({
    type: SET_FULL_EDUCATIONLIST,
    payload: value
})

export const setZodiacSigns = value => ({
    type: SET_ZODIACSIGNS,
    payload: value
})

export const setFlaws = value => ({
    type: SET_FLAWS,
    payload: value
})

export const setStatus = value => ({
    type: SET_STATUS,
    payload: value
})

export const setOccupation = value => ({
    type: SET_OCCUPATION,
    payload: value
})

export const setAllStars = value => ({
    type: SET_ALLSTARS,
    payload: value
})

export const setFullOccupation = value => ({
    type: SET_FULL_OCCUPATIONS,
    payload: value
})

export const setTEducation = value => ({
    type: SET_TEDUCATIONS,
    payload: value
})

export const setTFlaws = value => ({
    type: SET_TFLAWS,
    payload: value
})

export const setTStatus = value => ({
    type: SET_TSTATUS,
    payload: value
})

export const setTOccupation = value => ({
    type: SET_TOCCUPATION,
    payload: value
})

export const setDhisa = value => ({
    type: SET_DHISA,
    payload: value
})

export const setInitialLoadingFilter = value => ({
    type: SET_INITIAL_LOADING_FILTER,
    payload: value
})

export const setSearchValue = value => ({
    type: SET_SEARCH_VALUE,
    payload: value
})

export const setMaxAge = value =>({
    type:SET_MAX_AGE,
    payload :value
})

export const setMinAge = value=>({
    type:SET_MIN_AGE,
    payload:value
})

export const setSearchCount = value =>({
    type:SET_SEARCH_COUNT,
    payload:value
})

export const setTDhisa =value=>({
    type:SET_TDHISA,
    payload:value
})

export const setFetchUserDetails  = value =>({
    type:SET_FETCH_USER_DETAILS,
    payload:value
})